export const API_URL_USER_PROFILE = "settings/user_profile/";

export const API_URL_USER_ROLES = "settings/roles/";

export const API_URL_GET_CAN_EDIT_INTERNAL_USERS =
  "settings/user_profile/can_edit_internal_users/";

export const API_URL_DEACTIVATE_USERS =
  "settings/user_profile/deactivate_users/";

export const API_URL_CASE_ACTIONS = "case_actions";

export const API_URL_MY_ACTIONS = "my_actions";

export const API_URL_PROJECTS = "projects";

export const API_URL_KPIS = "kpis";

export const API_URL_CASES = "cases";

export const API_URL_EMAIL_SCHEDULE_SETTINGS =
  "settings/email_schedule_settings";

export const API_URL_INTEGRATION_USER_SETTINGS = "settings/integration_user";

export const API_URL_SCHEDULED_RUNS = "settings/scheduled_runs";

export const REPORT_SECTIONS = "report_sections";
export const REPORT_GENERATE = "report/generate";
